<template>
  <div class="private-ad-variant-list" id="PrivateAdVariantList">
    <div v-if="variantList.length > 0">
      <div class="step__circle">
        <Arrow direction="down"></Arrow>
      </div>
      <p class="error" v-if="inputError">
        <span>{{ inputError }}</span>
        <span class="error__attention"></span>
      </p>
      <div class="private-ad-variant-list__header">
        <p class="private-ad-variant-list__header-title">
          Vælg variant (udstyrspakke)
          <span v-if="variantList.length > 1">*</span>
        </p>
        <span class="private-ad-variant-list__header-state"
          >{{ variantList.length }}
          {{ variantList.length > 1 ? 'varianter' : 'variant' }}</span
        >
      </div>

      <div
        class="private-ad-variant-list__wrap"
        v-for="item in variantList"
        :key="item.variantId"
      >
        <div
          @click.prevent="onClick(item.variantId)"
          class="private-ad-variant-list__item"
          :class="{
            'private-ad-variant-list__item--selected':
              item.variantId == activeItemId,
          }"
        >
          <div class="private-ad-variant-list__item-side">
            <div class="private-ad-variant-list__item-side-inner"></div>
          </div>
          <div class="private-ad-variant-list__list">
            <div class="private-ad-variant-list__element">
              <p class="private-ad-variant-list__label">Mærke</p>
              <p class="private-ad-variant-list__value">{{ item.make }}</p>
            </div>
            <div class="private-ad-variant-list__element">
              <p class="private-ad-variant-list__label">Model</p>
              <p class="private-ad-variant-list__value">{{ item.model }}</p>
            </div>
            <div class="private-ad-variant-list__element--full">
              <p class="private-ad-variant-list__label">Variant</p>
              <p class="private-ad-variant-list__value">
                {{ item.variant }}
              </p>
            </div>
            <div
              class="private-ad-variant-list__element"
              v-for="(property, index) in item.propertyList"
              :key="'variant' + index"
            >
              <p class="private-ad-variant-list__label">{{ property.name }}</p>
              <p class="private-ad-variant-list__value">
                {{ property.valueText }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="variantList.length > 1">
        <p class="text-xss">
          * Der kan være flere varianter på samme nummerplade, da vi udfra
          nummerpladen ikke kan se info omkring varianten / udstyrspakken. Her
          skal du selv vælge den du mener der er den rigtige. Du bør kunne se
          varianten på din slutseddel fra dengang du købte bilen.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollAnimate } from '@/functions'
import Arrow from '@components/Shared/Arrow/Arrow.vue'

export default {
  components: {
    Arrow,
  },
  data() {
    return {
      activeItemId: 0,
      inputError: '',
    }
  },
  methods: {
    setError(error) {
      this.inputError = error
    },
    onClick(id) {
      this.setError('')
      this.activeItemId = id
      if (this.eventBus == null) return
      this.eventBus.emit('variant-selection-callback', id)
      // Scroll down to next button
      const element = document.getElementById('StepButtonPanel')
      if (element == null) return
      const pos = element.offsetTop + element.clientHeight - window.innerHeight
      scrollAnimate(document.documentElement, pos, 'scrollTop', 300)
      // Fix til Safari v12 og derunder (iphone 8 og ældre)
      scrollAnimate(document.body, pos, 'scrollTop', 300)
    },
    isValid() {
      return this.activeItemId !== 0
    },
  },
  props: {
    variantList: {
      default: () => {
        return []
      },
      type: Array,
    },
    eventBus: { default: null, type: Object },
  },
  watch: {
    variantList: {
      handler() {
        if (this.activeItemId !== 0) {
          this.activeItemId = 0
          this.eventBus.emit('variant-selection-callback', this.activeItemId)
        }
      },
    },
  },
}
</script>

<style lang="scss">
@import 'PrivateAdVariantList.scss';
</style>
